module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Auswahl Client",
      "dark": "",
      "cache-items": "",
      "required": "",
      "items": _vm.ccClients,
      "item-text": "name",
      "item-value": "id",
      "return-object": ""
    },
    model: {
      value: (_vm.ccClient),
      callback: function($$v) {
        _vm.ccClient = $$v
      },
      expression: "ccClient"
    }
  })], 1), _vm._v("\n    <\n")], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa087272","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/clientsSelectSingle.vue
// module id = 354
// module chunks = 0